import { type FC } from 'react';
import { Text } from '@mantine/core';
import Countdown from 'react-countdown';
import dayjs from 'dayjs';
import { OrderCountdownValue } from './components';

interface OrderCountdownProps {
    expiresAt?: string;
}

export const OrderCountdown: FC<OrderCountdownProps> = ({ expiresAt }) => {
    if (!expiresAt) {
        return null;
    }

    const expiresAtDate = dayjs(expiresAt);

    if (!expiresAtDate.isValid()) {
        return null;
    }

    const now = dayjs();

    if (expiresAtDate.isBefore(now) || expiresAtDate.isSame(now)) {
        return <Text>-</Text>;
    }

    return (
        <Countdown
            date={expiresAt}
            renderer={OrderCountdownValue}
        />
    );
};
